import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import './Login.css';

function PatientLogin() {
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  async function handleSendOtp(e) {
    e.preventDefault();

    if (phone.length !== 10) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }

    try {
      setError('');
      setSuccess('');
      setLoading(true);

      setTimeout(() => {
        setShowOtpInput(true);
        setLoading(false);
        setSuccess('OTP sent to +91 ' + phone);
      }, 1000);

    } catch (err) {
      setError('Failed to send OTP');
      setLoading(false);
    }
  }

  async function handleVerifyOtp(e) {
    e.preventDefault();

    if (otp.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }

    try {
      setError('');
      setSuccess('');
      setLoading(true);

      setTimeout(() => {
        if (otp === '123456') {
          navigate('/patient-dashboard');
        } else {
          setError('Invalid OTP (use 123456 for demo)');
          setLoading(false);
        }
      }, 1000);

    } catch (err) {
      setError('Failed to verify OTP');
      setLoading(false);
    }
  }

  return (
    <>
      <Navbar />
      <div className="login-wrapper">
        <div className="login-background-pattern"></div>
        <div className="login-container-centered">
          <motion.div
            className="login-card"
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
          >
            <div className="login-card-header">
              <h1>Patient Portal</h1>
              <p className="login-subtitle">Your health records, prescriptions & appointments - all in one place</p>
            </div>

            {error && <div className="alert-error">{error}</div>}
            {success && <div className="alert-success">{success}</div>}

            {!showOtpInput ? (
              <form onSubmit={handleSendOtp}>
                <div className="input-group">
                  <label>Phone number</label>
                  <div className="phone-wrapper">
                    <span className="phone-prefix">+91</span>
                    <input
                      type="tel"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                      required
                      placeholder="9876543210"
                      maxLength="10"
                    />
                  </div>
                </div>

                <button type="submit" disabled={loading} className="btn-primary">
                  {loading ? 'Sending...' : 'Send OTP'}
                </button>
              </form>
            ) : (
              <form onSubmit={handleVerifyOtp}>
                <div className="input-group">
                  <label>Enter OTP</label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    required
                    placeholder="123456"
                    maxLength="6"
                  />
                  <p className="input-hint">Sent to +91 {phone}</p>
                </div>

                <button type="submit" disabled={loading} className="btn-primary">
                  {loading ? 'Verifying...' : 'Verify OTP'}
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setShowOtpInput(false);
                    setOtp('');
                    setError('');
                    setSuccess('');
                  }}
                  className="btn-secondary"
                >
                  Change phone number
                </button>
              </form>
            )}

            <div className="login-footer">
              <button onClick={() => navigate('/')} className="link-button">
                ← Back to portal selection
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}

export default PatientLogin;